// BT-CUSTOM: vores egen JS ("vis alle billeder", max 5 farveprikker + "N farver", genkørsel ved nye kort).
// Flyttet ud af assets/custom.js ved opdatering til Venue 18.2.2 (2026-09-22). Ingen afhængigheder (jQuery fjernet 2026-09-22 af hensyn til hastighed).

// 2026-09-22: "Vis alle billeder"-knappen (#load-all-images, jQuery) fjernet: knappen findes ikke i temaet
// (heller ikke i live 16.0), saa koden koerte aldrig. Dermed bruger vi ikke jQuery mere.

const MOBILE_BREAKPOINT = 768;
const MAX_VISIBLE_SWATCHES_MOBILE = 5;
const MAX_VISIBLE_SWATCHES_DESKTOP = 5;

function handleSwatches() {
  const productCards = document.querySelectorAll('.product-card');
  if (!productCards.length) return;

  const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

  const currentMaxSwatches = isMobile ? MAX_VISIBLE_SWATCHES_MOBILE : MAX_VISIBLE_SWATCHES_DESKTOP;

  productCards.forEach((card) => {
    const swatchWrapper = card.querySelector('.swatches .product-item__linked');
    if (!swatchWrapper) return;

    const swatches = Array.from(swatchWrapper.querySelectorAll('.product-item__linked-item'));

    const existingCountElements = swatchWrapper.querySelectorAll('.swatch-more-count');
    existingCountElements.forEach(el => el.remove());

    swatches.forEach(swatch => {
      swatch.classList.remove('swatch-hide');
    });

    if (swatches.length > currentMaxSwatches) {
      swatches.forEach((swatch, index) => {
        if (index >= currentMaxSwatches) {
          swatch.classList.add('swatch-hide');
        }
      });

      const countElement = document.createElement('a');
      countElement.href = swatchWrapper.dataset.url;
      countElement.classList.add('swatch-more-count');
      countElement.textContent = `${swatches.length} farver`;
      swatchWrapper.appendChild(countElement);
    }
  });
}

document.addEventListener('DOMContentLoaded', handleSwatches);
window.addEventListener('resize', handleSwatches);

// Produktkort der loades bagefter (anbefalinger, filtrering, "load more")
// findes ikke ved DOMContentLoaded — kør igen når nye kort dukker op.
document.addEventListener('DOMContentLoaded', function () {
  let pending = null;

  new MutationObserver(function (mutations) {
    const gotNewCards = mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes).some(function (node) {
        if (node.nodeType !== 1) return false;
        return node.matches('.product-card') || node.querySelector('.product-card');
      });
    });

    if (!gotNewCards) return;

    clearTimeout(pending);
    pending = setTimeout(handleSwatches, 100);
  }).observe(document.body, { childList: true, subtree: true });
});

// BT-CUSTOM: hover-billedskift paa farveprikker for kort der hentes bagefter (anbefalinger, filtrering).
// Kaldes fra dynamic-product-search.js og product-recommendations.js. Samme kode som laa inline i de to filer i live 16.0.
window.btBindSwatchHover = function () {
  document.querySelectorAll('.product-item__linked-item').forEach(function (el) {
    el.addEventListener('mouseenter', function () {
    var productCard = el.closest('.product-card, [product-card]');
    if (!productCard) return;
    var img = productCard.querySelector('.product-card__img');

    var newImgUrl = el.getAttribute('url_img') || el.getAttribute('data-url_img');
    if (img && newImgUrl) {
        img.dataset.originalSrc = img.dataset.originalSrc || img.src;
        img.src = newImgUrl;
        img.removeAttribute('srcset');
    }
    });
  });
};
